import React from 'react';
export function Footer() {
  return <footer className="bg-brand-black py-10 border-t border-white/5" data-id="element-29">
      <div className="max-w-7xl mx-auto px-6 md:px-12 flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-30">
        <div className="flex items-center gap-6" data-id="element-31">
          <img src="https://cdn.magicpatterns.com/uploads/njzqrqDh79LXJM1gwhkevk/morley.svg" alt="Morley" className="h-6" data-id="element-32" />
          <span className="hidden md:block w-px h-4 bg-white/10" data-id="element-33"></span>
          <p className="text-brand-muted text-xs font-light" data-id="element-34">
            11 Northcote Street, Richmond VIC 3121
          </p>
        </div>

        <p className="text-brand-muted/40 text-xs font-light" data-id="element-35">
          &copy; {new Date().getFullYear()} Morley Commercial
        </p>
      </div>
    </footer>;
}